<template>
  <transition name="fade">
    <div class="pruanjianpan p2 showcontainervue z102" style="background:#FFF"></div>>
  </transition>
</template>
<script>
import { mapState } from "vuex";
import $ from "jquery";
import {
  Engine,
  Render,
  World,
  Bodies,
  Body,
  Events,
  Composite,
  Composites,
  Constraint,
  Vertices,
  Mouse,
  MouseConstraint,
  Runner,
  Common
} from "matter-js";
export default {
  name: "hecheng",
  data() {
    return {};
  },
  watch: {
    isshowp2(val) {
      if (val == 1) {
        this.initpage();

      } else {
        this.destroypage();
      }
      console.log(val);
    },
  },
  components: {},

  beforeMount() { },
  mounted() {
    $('body').before('<div id="fps" style="z-index:10000;position:fixed;top:3;left:3;font-weight:bold;color:#FFF;"></div>');
    var showFPS = (function () {
      var requestAnimationFrame =
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
          window.setTimeout(callback, 1000 / 60);
        };
      var e, pe, pid, fps, last, offset, step, appendFps;

      fps = 0;
      last = Date.now();
      step = function () {
        offset = Date.now() - last;
        fps += 1;
        if (offset >= 1000) {
          last += offset;
          appendFps(fps);
          fps = 0;
        }
        requestAnimationFrame(step);
      };
      appendFps = function (fps) {
        console.log(fps + 'FPS');
        $('#fps').html(fps + 'FPS');
      };
      step();
    })();



    // create engine
    var engine = Engine.create(),
      world = engine.world;

    // create renderer
    var render = Render.create({
      element: $('.p2')[0],
      engine: engine,
      options: {
        width: 800,
        height: 600,
        showAngleIndicator: true
      }
    });

    Render.run(render);

    // create runner
    var runner = Runner.create();
    Runner.run(runner, engine);

    // add bodies
    var stack = Composites.stack(20, 20, 20, 5, 0, 0, function (x, y) {
      return Bodies.circle(x, y, Common.random(10, 20), { friction: 0.00001, restitution: 0.5, density: 0.001 });
    });

    World.add(world, stack);

    World.add(world, [
      Bodies.rectangle(200, 150, 700, 20, { isStatic: true, angle: Math.PI * 0.06 }),
      Bodies.rectangle(500, 350, 700, 20, { isStatic: true, angle: -Math.PI * 0.06 }),
      Bodies.rectangle(340, 580, 700, 20, { isStatic: true, angle: Math.PI * 0.04 })
    ]);

    // add mouse control
    var mouse = Mouse.create(render.canvas),
      mouseConstraint = MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: {
          stiffness: 0.2,
          render: {
            visible: false
          }
        }
      });

    World.add(world, mouseConstraint);
  },

  methods: {
    initpage() {
      console.log("弹出页面");
    },
    destroypage() {
      console.log("消失页面");
    },
    resload() {
      console.log('资源加载完成');
    },
    refresh() {
      // 刷新页面加载的逻辑
    }
  },
  computed: {
    ...mapState(["isalljiazai", "isshowp2"]),
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/hecheng.vue